import styled from 'styled-components';

export const RightContainer = styled.div`
    flex: 1;
    margin-left: 10px;
    margin-right: 10px;
    max-width: 410px;

    .rightInnerContainer {
        flex-direction: column;
        flex: 1;
        background-color: ${props => props.theme.white};
        width: 100%;
        align-self: flex-start;
        padding: 0 20px 20px;

        &.bordered {
            border: 1px solid ${props => props.theme.whiteGrey};
        }
        &.bordered-no-top {
            border-left: 1px solid ${props => props.theme.whiteGrey};
            border-right: 1px solid ${props => props.theme.whiteGrey};
            border-bottom: 1px solid ${props => props.theme.whiteGrey};
        }

        h3 {
            margin: 20px 0;
        }

        &.ebonRecap {
            margin-top: 30px;
        }

        &.ebonTotal {
            div.shiping {
                padding-top: 20px;

                p {
                    font-weight: ${props => props.theme.regularWeight};
                }
            }

            div.total,
            div.cashback {
                align-items: center;
                font-weight: ${props => props.theme.regularWeight};

                div {
                    span {
                        font-size: 22px;
                    }
                }
            }

            div.cashback {
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
                color: ${props => props.theme.primary};

                p {
                    max-width: 245px;
                }
            }
        }

        &.ebonRecap,
        &.ebonTotal {
            div {
                display: flex;

                p {
                    flex: 4 1;
                }

                span {
                    font-weight: ${props => props.theme.boldWeight};
                    display: flex;
                    justify-content: center;
                    flex: 1 1;
                }
            }
        }
    }

    @media (max-width: ${props => props.theme.medium}) {
        margin-left: 0;
        margin-right: 0;
        width: 100%;
    }
`;



// WEBPACK FOOTER //
// ./src/components/funnel/FunnelRightContainerStyle.js